var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M12 2c5.524 0 10 4.476 10 10s-4.476 10-10 10S2 17.524 2 12 6.476 2 12 2zm-1.165 5.79l3.044 2.92H6.516c-.536 0-.968.431-.968.967v.646c0 .536.432.967.968.967h7.363l-3.044 2.92c-.391.375-.4 1-.016 1.383l.443.44c.38.378.992.378 1.367 0l5.35-5.348c.38-.379.38-.991 0-1.366l-5.35-5.355c-.379-.38-.992-.38-1.367 0l-.443.44c-.384.386-.375 1.011.016 1.386z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow-circle.2577c94b4303ac1aa186475c886c0707.svg";
export { ForwardRef as ReactComponent };